import { render, staticRenderFns } from "./OsCard.vue?vue&type=template&id=3bc2702e&scoped=true"
import script from "./OsCard.vue?vue&type=script&lang=ts"
export * from "./OsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc2702e",
  null
  
)

export default component.exports